import { useState } from 'react';
import { Button, Input } from 'components/ui';
import { isValidPhone } from 'lib/validators';

/**
 * Step 1 of login — collect the vendor's phone number.
 *
 * NOTE: the "+91" prefix is cosmetic. The number is sent to the backend exactly
 * as typed (digits only). Adjust here if your API expects an E.164 number.
 */
export function PhoneStep({ onSubmit, isSubmitting, error, initialPhone = '' }) {
  const [phone, setPhone] = useState(initialPhone);
  const [touched, setTouched] = useState(false);
  const valid = isValidPhone(phone);

  const handleSubmit = (event) => {
    event.preventDefault();
    setTouched(true);
    if (valid) onSubmit(phone);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4" noValidate>
      <Input
        label="Phone number"
        type="tel"
        inputMode="numeric"
        autoComplete="tel"
        leftAddon="+91"
        placeholder="98765 43210"
        value={phone}
        onChange={(event) => setPhone(event.target.value)}
        onBlur={() => setTouched(true)}
        error={touched && !valid ? 'Enter a valid phone number.' : undefined}
        autoFocus
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
      <Button type="submit" fullWidth size="lg" isLoading={isSubmitting} disabled={!valid}>
        Send OTP
      </Button>
    </form>
  );
}

export default PhoneStep;
